import type { DescriptionPage_ProductVariant as ProductVariant } from '__generated__/graphql-types';

import { redirectClientOrServer } from 'bundles/common/utils/urlUtils';
import {
  getConsumerRouteForSpecializationProducts,
  getEnterpriseRouteForSpecializationProducts,
} from 'bundles/unified-description-page-common/utils/getRouteForSpecializationProducts';

type Params = {
  slug: string;
  productVariant: ProductVariant;
  orgSlug?: string;
  programSlug?: string;
};

/**
 * If the learner isn't part of the specialization/professional-certificate reviews experiment,
 * bounce them back to the product's own XDP instead of rendering this page. Must be called
 * directly during render (not inside useEffect), before any early return in the calling
 * component, so redirectClientOrServer's SSR branch can throw before any markup renders.
 * Takes `productVariant` from the route (not the page data query) so the redirect doesn't have to
 * wait on that query to resolve.
 */
export const guardSpecializationReviewsPage = (
  showReviews: boolean,
  { slug, productVariant, orgSlug, programSlug }: Params
) => {
  if (showReviews) {
    return;
  }

  const redirectUrl =
    orgSlug || programSlug
      ? getEnterpriseRouteForSpecializationProducts(productVariant, slug, programSlug, undefined, orgSlug)
      : getConsumerRouteForSpecializationProducts(productVariant, slug);

  redirectClientOrServer(redirectUrl);
};
